import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { GlobalPriceChartLog } from "./global-price-chart-log.entity";
import { GlobalPriceType } from "@gtpl/shared-models/masters";

@Entity('global_price_chart')
export class GlobalPriceChart {
    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;

    @Column('varchar',{
        name:'component',
        length:100,
        nullable:false
    })
    component: string

    @Column('decimal',{
        name:'price',
        precision:10,
        scale:2,
        nullable:false
    })
    price: number

    @Column("enum", {
        nullable: false,
        name: "type",
        enum:GlobalPriceType,
        default:GlobalPriceType.Value
      })
      type: GlobalPriceType;
    @CreateDateColumn({
        name:'created_at',
        type:'datetime'
    })
    createdAt: Date

    @Column('varchar',{
        name:'created_user',
        nullable: true
    })
    createdUser: string | null

    @UpdateDateColumn({
        name:'updated_at',
        nullable:true
    })
    updatedAt: Date

    @Column('varchar',{
        name:'updated_user',
        nullable:true
    })
    updatedUser: string | null
    
    @VersionColumn({
        name:'version_flag',
        default:1,
    })
    versionFlag: number
@Column("boolean", {
        nullable:true,
        default:true,
        name: "is_costing"
      })
      isCosting: boolean;
    @OneToMany(type=> GlobalPriceChartLog,gpcl=>gpcl.gpcInfo,{cascade:true})
    gpclInfo:GlobalPriceChartLog[]
}